<template>
  <div>
    <template>
      <v-card class="mx-auto" justifiy="center" align="center">
        <v-app-bar class="transparent" light flat>
          <v-toolbar-title>
            <v-btn icon @click.stop="$router.go(-1)">
              <v-icon>mdi-arrow-left-circle-outline</v-icon> </v-btn
            >{{ $route.query.ll_dotation }} </v-toolbar-title
          ><v-spacer></v-spacer>
        </v-app-bar>

        <v-card flat v-if="detailsDotation">
          <v-card-text>
            <v-layout row justify-center>
              <v-dialog v-model="editDialog" max-width="350">
                <v-card>
                  <v-card-title>
                    <span class="headline">Editer Sexe</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="form">
                      <v-container fluid>
                        <v-row no-gutters="">
                          <v-col cols="12">
                            <v-radio-group v-model="editedItem.sexe" row>
                              <v-radio
                                label="Masculin"
                                :value="parseInt(1)"
                              ></v-radio>
                              <v-radio
                                label="Féminin"
                                :value="parseInt(0)"
                              ></v-radio>
                            </v-radio-group>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn rounded color="info" @click.native="closeDialog()"
                      >Annuler</v-btn
                    >
                    <v-btn
                      rounded
                      color="primary"
                      @click.native="updateMembre()"
                      >Mettre à jour</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-layout>
            <div>Dotation dans le cadre de :</div>
            <div class="font-weight-bold">
              {{ detailsDotation.ll_parcours }}
            </div>
            <div>Groupe : {{ detailsDotation.nom_groupe }}</div>
            <div>Animateur : {{ detailsDotation.nom_responsable }}</div>
            <div>
              {{
                $moment(detailsDotation.date_dotation).format("Do MMMM YYYY")
              }}
            </div>

            <v-simple-table style="width: 500px;">
              <thead>
                <tr>
                  <th scope="col">&nbsp;</th>
                  <th scope="col">Données totales</th>
                  <th scope="col">Détails</th>
                  <!--  <th scope="col">Etat</th> -->
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Total</td>
                  <td>
                    {{ detailsDotation.nombreTotal }}
                  </td>
                  <td>
                    {{ membresPresents.total }}
                  </td>
                  <!--    <td>
                    <div
                      v-if="
                        detailsDotation.nombreTotal ===
                        membresPresents.total
                      "
                    >
                      <v-icon color="green darken-2">
                        mdi-check
                      </v-icon>
                    </div>
                    <div v-else>
                      <v-icon color="error">
                        mdi-alert
                      </v-icon>
                    </div>
                  </td> -->
                </tr>
              </tbody>
            </v-simple-table>
            <!--  <div>Date de Fusion: {{ detailsDotation.dateFusion }}</div> -->
            <div>Opérateur: {{ detailsDotation.operateur }}</div>
            <!--         <v-btn
              class="warning my-4"
              v-if="user.role != 'superviseur'"
              rounded
              @click="fusionner()"
              >Fusionner <v-icon right dark>mdi-reload</v-icon></v-btn
            > -->
          </v-card-text>
          <!--  <v-card-text  v-if="user.role != 'superviseur'  || user.isPaysanRelais"> -->
          <v-card-text v-if="user.role != 'superviseur'">
            <div class="flex-table">
              <div>Nom</div>
              <div>Age</div>
              <div>Sexe</div>
              <div>Actions</div>
            </div>
            <div
              class="flex-table"
              v-for="(item, index) in membresPresents.listePresents"
              :key="index"
              v-bind:class="{
                'grey lighten-1 ': item.actif_dans_groupe === 0,
              }"
            >
              <div>{{ item.nom }}</div>

              <div>
                {{ calculate_age(new Date(item.annee_naissance, 1, 1)) }} ans
              </div>
              <div>{{ getSexe(item.sexe) }}</div>

              <div v-if="item.sexe !== 1 || item.sexe !== 0">
                <v-sheet class="d-flex mb-6 bg-surface-variant">
                  <v-sheet class="ma-2 pa-6"
                    ><v-btn
                      icon
                      color="primary"
                      class="elevation-2"
                      @click="createPresenceDotationDeGroupe(item)"
                    >
                      <v-icon>mdi-content-save-all</v-icon></v-btn
                    ></v-sheet
                  >
                  <v-sheet class="ma-2 pa-6">
                    <v-text-field
                      v-model="item.nombre"
                      label="Nombre"
                      type="number"
                      outlined
                      dense
                      @focus="checkPresence(item)"
                    ></v-text-field
                  ></v-sheet>
                </v-sheet>
              </div>

              <div v-else class="div">
                <v-btn
                  color="grey lighten-2 mr-4"
                  fab
                  class="elevation-0"
                  @click="showEditDialog(item)"
                >
                  <v-icon>mdi-account-edit-outline</v-icon>
                </v-btn>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="success" @click.stop="$router.go(-1)"
              >Sauvegarder</v-btn
            >
          </v-card-actions>
        </v-card>

        <v-card-actions>
          <Navigation :elements="SuperviseurNavigation" />
        </v-card-actions>
      </v-card>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {
    this.GetMembresDuGroupe(this.$route.query.idGroupe);
    this.getDetailsDotationDeGroupe(this.$route.params.id);
    this.GetPresencesDotationsDeGroupeByIdDotation(this.$route.params.id);
  },
  data() {
    return {
      detailsDotation: null,
      membrePresent: false,
      checkbox: [],
      totalCalcule: 0,
      editDialog: false,
      editedItem: {},
    };
  },
  components: {
    Navigation: require("@/components/Navigation.vue").default,
  },
  methods: {
    /*     fusionner() {
      let self = this;
      console.log("fusionner");

      this.$firebase
        .firestore()
        .collection("dotationsDeGroupe")
        .doc(self.detailsDotation.id)
        .set(
          {
            fusion: true,
            dateFusion: self.$moment(Date.now()).format("YYYY-MM-DD HH:mm:ss"),
            operateur: self.user.displayName,
          },
          { merge: true }
        )
        .then(function () {
          console.log("Document successfully written!");
          self.getDetailsDotationDeGroupe(self.detailsDotation.id);
        })
        .catch(function (error) {
          console.error("Error writing document: ", error);
        });
    }, */

    showEditDialog(item) {
      this.editDialog = true;
      this.editedItem = item;
    },
    closeDialog() {
      this.editDialog = false;
    },

    updateMembre() {
      const self = this;
      var luser = {
        sexe: self.editedItem.sexe,
      };

      console.log(luser);

      var ref = self.$firebase
        .firestore()
        .collection("membres")
        .doc(self.editedItem.id);
      ref
        .set(luser, { merge: true })
        .then(function () {
          console.log("membre successfully updated!");
          var objet = { userId: self.editedItem.id, data: luser };
          self.UpdateMembreDansAutresCollections(objet);
          self.code_menage_selected = false;
          self.editDialog = false;
          self.GetMembresDuGroupe(self.editedItem.id_groupe);
        })
        .catch(function (error) {
          console.error("Error updating document: ", error);
          self.GetMembresDuGroupe(self.editedItem.id_groupe);
          self.GetMembresDuGroupeInactifs(self.editedItem.id_groupe);

          self.editDialog = false;
        });
    },

    printPresence() {
      var objectToSend = {
        detailsDotation: this.detailsDotation,
        membres: this.MembresDuGroupeActifs,
      };

      this.$router.push({
        name: "groupes-presenceDotationGroupe-print",
        params: objectToSend,
      });
    },
    getDetailsDotationDeGroupe(idDotation) {
      const self = this;
      //console.log("idDotation de Groupe:", idDotation);
      var docRef = this.$firebase
        .firestore()
        .collection("dotationsDeGroupe")
        .doc(idDotation);
      docRef
        .get()
        .then(function (doc) {
          if (doc.exists) {
            //console.log("Document data:", doc.data());
            self.detailsDotation = doc.data();
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
        });
    },

    checkPresence(membre) {
      let self = this;
      this.$firebase
        .firestore()
        .collection("presencesDotationsGroupes")
        .where("membres_id_membre", "==", membre.id)
        .where(
          "dotations_groupes_id_dotation_groupe",
          "==",
          self.$route.params.id
        )
        .get()
        .then(function (doc) {
          if (!doc.empty) {
            self.membrePresent = true;
          } else {
            self.membrePresent = false;
          }
          //console.log("membrePresent",self.membrePresent)
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
        });
    },

    createPresenceDotationDeGroupe(membre) {
      let self = this;
      console.log("nombre", membre.nombre);

      if (
        membre.nombre === undefined ||
        membre.nombre === "" ||
        membre.nombre.toString() === "0"
      ) {
        console.log("Effacer");
        self.deletePresenceDotationDeGroupe(membre);
      } else {
        if (self.membrePresent) {
          console.log("update");
          self.updatePresenceDotationDeGroupe(membre);
        } else {
          console.log("nouveau");
          let uuid = "**-----------000000000000000aaaa-" + this.$uuid.v4();

          const newItem = {
            nom_groupe: membre.nom_groupe,
            nom_responsable: membre.nom_responsable,
            ll_fokontany: membre.ll_fokontany,
            ll_district: membre.ll_district,
            nom: membre.nom,
            //code_menage: membre.code_menage,
            id_district: membre.id_district,
            groupes_id_groupe: membre.id_groupe,
            ll_region: membre.ll_region,
            sexe: membre.sexe,
            id_region: membre.id_region,
            id_responsable: membre.id_responsable,
            ll_commune: membre.ll_commune,
            annee_naissance: membre.annee_naissance,
            code_fokontany: membre.code_fokontany,
            membres_id_membre: membre.id,
            id_commune: membre.id_commune,
            village: membre.village,
            //ll_province: this.detailsDotation.ll_province,
            //id_province: this.detailsDotation.id_province,
            themes_id_theme: this.detailsDotation.themes_id_theme,
            ll_programme: this.detailsDotation.ll_programme,
            parcours_id_parcours: this.detailsDotation.parcours_id_parcours,
            ll_theme: this.detailsDotation.ll_theme,
            programmes_id_programme: this.detailsDotation
              .programmes_id_programme,
            ll_parcours: this.detailsDotation.ll_parcours,
            description_parcours: this.detailsDotation.description_parcours,
            ll_dotation_groupe: this.$route.query.ll_dotation,
            dotations_groupes_id_dotation_groupe: this.$route.params.id,
            abbr_parcours: this.detailsDotation.abbr_parcours,
            date_dotation_groupe: this.detailsDotation.date_dotation,
            bailleurs_id_bailleur: this.detailsDotation.bailleurs_id_bailleur,
            ll_bailleur: this.detailsDotation.ll_bailleur,
            objectifs: this.detailsDotation.objectifs,
            abbr_bailleur: this.detailsDotation.abbr_bailleur,
            nombre: membre.nombre,
          };

          console.log("newItem", newItem);
          this.$firebase
            .firestore()
            .collection("presencesDotationsGroupes")
            .doc(uuid)
            .set(newItem, { merge: true })
            .then(() => {
              console.log("Dotation de groupe créé id: " + uuid);
              self.GetPresencesDotationsDeGroupeByIdDotation(
                self.$route.params.id
              );
              this.GetMembresDuGroupe(membre.id_groupe);
            })
            .catch((error) => {
              console.error("Error writing document: ", error);
            });

          // vuex insert presencesFormationsGroupes
          this.addOneItem(newItem);
        }
      }

      //this.$router.go(0);
    },
    async deletePresenceDotationDeGroupe(membre) {
      let self = this;

      const doc = await this.$firebase
        .firestore()
        .collection("presencesDotationsGroupes")
        .where("membres_id_membre", "==", membre.id)
        .where(
          "dotations_groupes_id_dotation_groupe",
          "==",
          self.$route.params.id
        )
        .get();
      doc.forEach((element) => {
        element.ref.delete();
        console.log(`deleted: ${element.id}`);
        self.GetPresencesDotationsDeGroupeByIdDotation(self.$route.params.id);
      });
    },

    async updatePresenceDotationDeGroupe(membre) {
      let self = this;
      const ITEMS = this.$firebase
        .firestore()
        .collection("presencesDotationsGroupes");

      ITEMS.where("membres_id_membre", "==", membre.id)
        .where(
          "dotations_groupes_id_dotation_groupe",
          "==",
          self.$route.params.id
        )
        .get()
        .then((snapshots) => {
          self.GetPresencesDotationsDeGroupeByIdDotation(self.$route.params.id);
          if (snapshots.size > 0) {
            snapshots.forEach((item) => {
              ITEMS.doc(item.id).update({ nombre: membre.nombre });
            });
          }
        });
    },

    getSexe(sexe) {
      if (sexe == "1") {
        return "Masculin";
      } else {
        return "Féminin";
      }
    },
    calculate_age(dob) {
      var diff_ms = Date.now() - dob.getTime();
      var age_dt = new Date(diff_ms);

      return Math.abs(age_dt.getUTCFullYear() - 1970);
    },
    ...mapActions({
      GetMembresDuGroupe: "Membres/GetMembresDuGroupe",
      GetPresencesDotationsDeGroupeByIdDotation:
        "PresencesDotationsDeGroupe/GetPresencesDotationsDeGroupeByIdDotation",
      addOneItem: "PresencesDotationsDeGroupe/addOneItem",
      UpdateMembreDansAutresCollections:
        "Membres/UpdateMembreDansAutresCollections",
      GetMembresDuGroupeInactifs: "Membres/GetMembresDuGroupeInactifs",
    }),
  },
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
      MembresDuGroupe: (state) => state.Membres.MembresDuGroupe,
      MembresDuGroupeActifs: (state) =>
        _.filter(state.Membres.MembresDuGroupe, { actif_dans_groupe: 1 }),
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      PresencesDotationsDeGroupe: (state) =>
        state.PresencesDotationsDeGroupe.PresencesDotationsDeGroupe,
      PresencesDotationsDeGroupeDeSuperviseur: (state) =>
        state.PresencesDotationsDeGroupe
          .PresencesDotationsDeGroupeDeSuperviseur,
    }),

    membresPresents: function () {
      let self = this;
      //console.log("******", this.$route.params.id)
      const idDotation = this.$route.params.id;
      /* const PresencesDelaDotation = _.filter(
        this.PresencesDotationsDeGroupe,
        { dotations_groupes_id_dotation_groupe: this.$route.params.id }
      ); */

      const idMembresPresents = [];

      _.forEach(this.PresencesDotationsDeGroupe, function (membrePresent, key) {
        var objet = {
          idMembre: membrePresent.membres_id_membre,
          nombre: membrePresent.nombre,
        };
        idMembresPresents.push(objet);
      });

      const listePresents = [];
      //const MembresDuGroupe = this.MembresDuGroupeActifs;
      const MembresDuGroupe = this.MembresDuGroupe;
      _.forEach(MembresDuGroupe, function (membre, key) {
        var found = _.find(idMembresPresents, { idMembre: membre.id });

        if (found) {
          membre.nombre = found.nombre;
        } else {
          membre.nombre = 0;
        }
        listePresents.push(membre);
      });
      var total = Object.values(listePresents).reduce(
        (r, { nombre }) => r + parseInt(nombre),
        0
      );

      if (total != 0) {
        //console.log("update Total ", total);
        //console.log("dotationsDeGroupe ", this.$route.params.id);
        // self.fusionner();
        var ref = this.$firebase
          .firestore()
          .collection("dotationsDeGroupe")
          .doc(this.$route.params.id);

        ref.set(
          {
            nbDetail: total,
            fusion: true,
            dateFusion: self.$moment(Date.now()).format("YYYY-MM-DD HH:mm:ss"),
            operateur: self.user.displayName,
          },
          { merge: true }
        );
      }

      var objet = {
        listePresents: listePresents,
        total,
      };
      return objet;
    },
  },
};
</script>

<style scoped>
.flex-table {
  display: grid;
  grid-template-columns: repeat(auto-fill, 25%);
  padding: 10px;
  border-bottom: 1px #ccc solid;
}
.inactif_dans_groupe {
  display: none;
}
</style>
